import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.dokument-lese-berechtigung-hinzufuegen-multi';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenDokumentLeseBerechtigungHinzufuegenMultiEffects {

    DokumentLeseBerechtigungHinzufuegenMulti$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_DOKUMENT_LESE_BERECHTIGUNG_HINZUFUEGEN_MULTI),
        mergeMap((x: ac.PostDokumentLeseBerechtigungHinzufuegenMultiAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postDokumentLeseBerechtigungHinzufuegenMulti(x.dokumentBerechtigungMultiRequest).pipe(
                map((result: any) => {
                    return new ac.PostDokumentLeseBerechtigungHinzufuegenMultiErfolgreichAction(result, x.dokumentBerechtigungMultiRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostDokumentLeseBerechtigungHinzufuegenMultiFehlerAction(error, x.dokumentBerechtigungMultiRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.DokumenteCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.DokumenteCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.DokumenteCommandService);
        }
        return this.service;
    }
}
